import type { MetricsDistributionResponse } from '../../../../../shared/api/types';

export interface ProgressBarData {
  label: string;
  value: number;
}

export const transformProgrammeGoals = (data: MetricsDistributionResponse | undefined): ProgressBarData[] => {
  if (!data?.data?.distribution || data.data.distribution.length === 0) return [];

  // Goals are multi-select: each goal's percentage is the share of
  // respondents who answered this question that picked it, computed
  // independently per goal — not the raw count. Totals can exceed 100%.
  // The chart renders this value with a "%" suffix.
  return data.data.distribution
    .map((item) => ({
      label: (item.label || item.name || 'Unknown')
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' '),
      value: item.percentage,
    }))
    .sort((a, b) => b.value - a.value);
};
